module.exports = __webpack_public_path__ + "static/media/Penn Frame Blue 2.43acfc02.png";